export class PlanModel {
  value: number;
  meta?: {
    loading?: boolean
  };
}
